// ============================================================================
// TIMETRACKER PRO - SINGLETON SUPABASE CLIENT
// ============================================================================
// This is the ONLY file where createClient should be called.
// All other files should import { supabase } from this file.
// ============================================================================

import { createClient } from '@supabase/supabase-js';

// Export these constants so other files can use the SAME values
// This ensures Edge Function calls use the same project as the Supabase client
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Graceful handling if env vars are missing (logs error but doesn't crash)
if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error('Missing Supabase environment variables!');
  console.error('Please create a .env file with:');
  console.error('REACT_APP_SUPABASE_URL=your-url');
  console.error('REACT_APP_SUPABASE_ANON_KEY=your-key');
}

// Create the singleton Supabase client with proper auth configuration
// - persistSession: true  → Store session in localStorage
// - autoRefreshToken: true → supabase-js handles token refresh automatically
// - detectSessionInUrl: true → Handle OAuth redirects
export const supabase = createClient(SUPABASE_URL || '', SUPABASE_ANON_KEY || '', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Explicit storage key to avoid conflicts
    storageKey: 'timetracker-pro-auth',
  }
});

// Helper function to check connection (RLS-safe)
export const testSupabaseConnection = async () => {
  try {
    // Guard against missing env vars
    if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
      return { ok: false, error: 'Missing Supabase configuration' };
    }
    
    const { data, error } = await supabase.auth.getSession();
    if (error) {
      console.error('❌ Supabase connection failed:', error.message);
      return { ok: false, error: error.message };
    }
    const hasSession = !!(data?.session);
    console.log('✅ Supabase connected successfully', hasSession ? '(authenticated)' : '(no session)');
    return { ok: true, hasSession };
  } catch (error) {
    console.error('❌ Supabase connection failed:', error.message);
    return { ok: false, error: error.message };
  }
};
